module.exports = __webpack_public_path__ + "img/home_x2.c13bc0bf.webp";